














import Vue from 'vue';
import {
  AccountActivityExpander,
  AccountExportTools,
  PostedTransactions,
} from '@/components/account-components';
import {
  dateFormat,
  datePickerFormat,
  dateFormatYYYYMMDD,
  dateTransactionFormat,
  PdfMake,
} from '@/constants';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import {
  MemberAccountResponseModel,
  PostedTransactionResponseModel,
  PostedTransactionsDatFilterParams,
  TableHeader,
} from '@/@types/member';
import { cloneDeep, isNil } from 'lodash';
import moment from 'moment';
import {
  ExtendMixins,
  // GenerateXLS,
} from '@/services';
import { ActivityPDF } from '@/mixins/pdf-mixins';
import { ActivityXLS } from '@/mixins/xls-mixins';

export default ExtendMixins(
  ActivityPDF,
  ActivityXLS,
).extend({
  name: 'Activity',
  beforeRouteEnter(to, from, next) {
    const promises = [
      store.dispatch('getPostedTransactions', to.params.id),
      store.dispatch('getPendingTransactions', to.params.id),
      store.dispatch('getAccountScheduledTransactions', to.params.id),
      store.dispatch('getAccountDetail', to.params.id),
    ];
    LoadingService.watchPromises(promises)
      .then(next)
      .catch((error) => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  computed: {
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.params.id);
    },
    accountKey(): string {
      return this.$route.params.id;
    },
    transactionSearchParams(): string {
      const queryString = new URLSearchParams(this.$store.getters.currentTransactionFilterParams);
      const params = queryString.toString();
      return params ? `?${params}` : '';
    },
    postedTransactions(): PostedTransactionResponseModel[] {
      return this.$store.getters.postedTransactions;
    },
  },
  components: {
    AccountActivityExpander,
    AccountExportTools,
    PostedTransactions,
  },
});
